const createSystem = {
  createSystem: {
    selectSystem: 'Selecteer het systeem waarvoor u een design review wenst:',
    residential: 'Residentieel',
    commercial: 'Commercieel',
    selectfromList:
      'Selecteer uit een lijst van bestaande Enlighten installaties',
    enterSystemName: 'Vul de naam van het systeem in',
    siteSelectionErrorMsg1: 'U heeft voor een ',
    siteSelectionErrorMsg2: ' systeem gekozen. Selecteer een ',
    siteSelectionErrorMsg3: ' systeem om verder te gaan.',
    commercialErrorMsg: 'commercieel',
    residentialErrorMsg: 'residentieel',
    createNewSystem: 'Maak een nieuwe installatie aan in Enlighten',
    systemName: 'Naam van het systeem',
    type: 'Type',
    thirdParty: 'In eigendom van derden ("ex": PPA of Geleased)',
    siteInformation: 'Locatie onderzoek',
    collapse: 'Inklappen',
    expand: 'Uitklappen',
    customerName: 'Naam van de klant',
    address: 'Adres',
    zipCode: 'Postcode',
    noOfMicroinverters: 'Aantal micro-omvormers',
    firstName: 'Voornaam',
    lastName: 'Achternaam',
    email: 'E-mail',
    phone: 'Telefoon',
    enlightenVersion: 'Enlighten Versie',
    myEnlighten: 'MyEnlighten',
    monitoring:
      'De eigenaar zal MyEnlighten ontvangen voor het monitoren van de systeemprestaties.',
    location: 'Locatie',
    streetAddress1: 'Adres 1',
    streetAddress2: 'Adres 2',
    required: 'Verplicht',
    zipCodePostal: 'Postcode',
    country: 'Land',
    owner: 'Eigenaar',
    state: 'Staat/provincie',
    city: 'Stad',
    deviceDetails: 'Apparaat details',
    enphaseGuideLine:
      'Enphase biedt richtlijnen en hulpmiddelen om installateurs te helpen bij het ontwerpen van een systeem binnen de juiste parameters.. De installateur en de gekwalificeerde elektricien zijn verantwoordelijk voor het definitieve ontwerp en de uitvoering.',
    confirm: 'Ik bevestig het volgende',
    authorized:
      'Ik ben gemachtigd om mij voor Enlighten te registreren namens de systeemeigenaar/gastheer, die mij toestemming heeft gegeven om deze informatie namens hem/haar bij Enphase in te dienen.',
    readUnderstand: `Ik heb de Enphase's`,
    privacyPolicy: 'Privacybeleid',
    and: 'en',
    terms: 'Gebruiksvoorwaarden',
    policy: 'het "Beleid” geleen en begrepen.',
    agreedForTerms1: 'Ik heb de',
    agreedForTerms2:
      'van Enphase Design Review Services gelezen en ga hiermee akkoord',
    termsAndCondition: 'Algemene voorwaarden',

    acknowledge:
      'De systeemeigenaar/gastheer heeft bevestigd dat hij het beleid heeft gelezen en begrepen.',
    informedSystemOwner:
      'Ik heb de systeemeigenaar/gastheer geïnformeerd dat mijn bedrijf de hoeveelheden en tijdstippen van zijn energieverbruik kan controleren en dat hij deze toestemming te allen tijde kan intrekken.',
    proceedCreateSystem:
      'Ga door zonder een nieuw systeem aan te maken of te linken',
    cancel: 'Annuleren',
    noOption: 'Geen opties',
    invalidPhoneNumber: 'Ongeldig telefoonnummer',
    invalidEmail: 'Ongeldige e-mail',
    australia: 'Australien',
    usa: 'Verenigde Staten',
    germany: 'Duitsland',
    belgium: 'België',
    austria: 'Oostenrijk',
    netherlands: 'Nederland',
    france: 'Frankrijk',
    switzerland: 'Zwitserland',
  },
};

export default createSystem;
